import { apiSlice } from 'store/slices/api/api-slice';
import { CardsSphereRequest, EditSphereResponse } from 'types/card/card-sphere';

export const editSphereApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getSphereData: builder.query<EditSphereResponse, string>({
            query: (params: string) => ({
                url: `/sphere/sphere/${params}`,
                method: 'GET',
            }),
        }),
        editSphere: builder.mutation<void, CardsSphereRequest>({
            query: (cardsSphereRequest: CardsSphereRequest) => ({
                url: `/sphere/update/${cardsSphereRequest.cardSphereId}`,
                method: 'PUT',
                body: { ...cardsSphereRequest },
            }),
        }),
    }),
});

export const { useGetSphereDataQuery, useEditSphereMutation } = editSphereApi;
